import { render, staticRenderFns } from "./PharmacistsFavoritesTabItem.vue?vue&type=template&id=120bc5a4&scoped=true&"
import script from "./PharmacistsFavoritesTabItem.vue?vue&type=script&lang=js&"
export * from "./PharmacistsFavoritesTabItem.vue?vue&type=script&lang=js&"
import style0 from "./PharmacistsFavoritesTabItem.vue?vue&type=style&index=0&id=120bc5a4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120bc5a4",
  null
  
)

export default component.exports